import React from "react";
import { Box, Typography } from "@mui/material";
import { QRCodeCanvas } from "qrcode.react";
import "@fontsource/prompt";
import logo from "../assets/images/leaf.png";
import chennailogo from "../assets/images/stsnlogo.png";

const capitalizeWords = (str) => {
  if (!str) return "";
  return str
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};



const TKSMemberCard = ({ member }) => {
    return (
        <Box
            sx={{
                width: '100%',
                maxWidth: 600,
                mx: 'auto',
                overflow: "hidden",
                fontFamily: "Prompt, sans-serif",
                boxShadow: 3,
                background: "linear-gradient(to bottom right, #fff2cc, #fff9e9)",
                position: "relative",
            }}
        >
            {/* Top Header with curve */}
            <Box
                sx={{
                    position: "relative",
                    background: "linear-gradient(to right, #fceabb, #f8b500)",
                    minHeight: 90,
                    display: "flex",
                    flexDirection: { xs: "column", sm: "row" },
                    alignItems: "center",
                    justifyContent: { xs: "center", sm: "flex-start" },
                    px: 2,
                    py: { xs: 2, sm: 0 },
                    gap: { xs: 1, sm: 2 }
                }}
            >
                <img
                    src={chennailogo}
                    alt="Logo"
                    style={{
                        height: 80,
                        width: "auto"
                    }}
                />
                <Typography
                    variant="h6"
                    sx={{
                        flex: 1,
                        textAlign: "center",
                        fontWeight: 600,
                        color: "red",
                        fontFamily: "Prompt, sans-serif",
                        fontSize: { xs: 16, sm: 18 }
                    }}
                >

                    சென்னை மாவட்ட சேனைத்தலைவர் சங்கம்
                    {/* Subtext below title */}
                    {/* <Typography
                        variant="caption"
                        sx={{
                            display: "block",
                            fontWeight: 400,
                            fontSize: { xs: "0.45rem", sm: "0.5rem" },
                            color: "#333",
                            mt: 0.5
                        }}
                    >
                        Unique Registration Number: AAFTTI126RF20251
                        <br /> (Provisionally approved u/s 80G(5)(vi) of Income Tax Act, 1961)
                    </Typography> */}
                </Typography>
                <img
                    src={logo}
                    alt="Logo"
                    style={{
                        height: 80,
                        width: "auto"
                    }}
                />
            </Box>

            {/* Direct Content on background */}
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexDirection: "row",
                    alignItems: "center",
                    px: 4,
                    py: 5,
                    gap: 2,
                }}
            >
                <Box sx={{ textAlign: "left", flex: 1 }}>
                    <Typography sx={{ fontWeight: 500, mb: 1.5, color: "black", fontSize: 16 }}>
                        NAME : {member.NAME}
                    </Typography>
                    <Typography sx={{ fontWeight: 500, mb: 1.5, color: "black", fontSize: 16 }}>
                        MOBILE NO : {member.MOBILE1}
                    </Typography>
                    <Typography sx={{ fontWeight: 500, mb: 1.5, color: "black", fontSize: 16 }}>
                        LOCATION : {capitalizeWords(member.AREA)}, {capitalizeWords(member.CITY)}
                    </Typography>
                    <Typography sx={{ fontWeight: 500, mb: 1.5, color: "black", fontSize: 16 }}>
                        PINCODE : {member.PINCODE}
                    </Typography>
                </Box>

                <Box sx={{ ml: 2, flexShrink: 0 }}>
                    <QRCodeCanvas
                        value={`NAME: ${member.NAME}\nMOBILE NO: ${member.MOBILE1}\nLOCATION: ${member.AREA},${member.CITY}\nPINCODE: ${member.PINCODE}`}
                        size={110}
                        bgColor="transparent"
                        fgColor="#000000"
                        level="L"
                        marginSize={-9}
                        imageSettings={{
                            src: "../assets/images/chennai_logo.png",
                            height: 20,
                            width: 20,
                            opacity: 1.1,
                            excavate: true,
                        }}
                    />
                </Box>
            </Box>

            {/* Bottom bar with shallow notch */}
            {/* Bottom Bar */}
            <Box
                sx={{
                    height: "250",
                    background: "linear-gradient(to right, #e21818, #ffe600)",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    px: 3,
                    py: 1.5,
                    flexDirection: { xs: "column", sm: "row" },
                    gap: 2,
                    //borderBottomRightRadius: "8px",
                    boxShadow: "0 6px 8px rgba(0, 0, 0, 0.1)",
                }}
            >
                {/* Left side text */}
                <Typography
                    variant="body2"
                    sx={{
                        fontWeight: 500,
                        color: "#ffff",
                        textAlign: { xs: "center", sm: "left" },
                        mb: { xs: 2, sm: 0 }
                    }}
                >
                    Project Office, Chennai.<br />
                    senaithalaivarsangam.in
                </Typography>

                {/* Right side contact info */}
                <Typography
                    variant="body2"
                    sx={{
                        fontWeight: 500,
                        color: "#000",
                        textAlign: { xs: "center", sm: "right" },
                        mt: { xs: 1, sm: 0 }
                    }}
                >
                    📞 +91 9841818740,044 2834 0028 <br />
                    ✉️ cnimavt.senaithalaivarsangam@gmail.com
                </Typography>








            </Box>
        </Box>
    );
};


export default TKSMemberCard;